import { extendTheme } from "@chakra-ui/react";

export default extendTheme({
  fonts: {
    heading: "Super scratchy",
    body: "Super scratchy",
  }
});